// extracted by mini-css-extract-plugin
module.exports = {"cause":"styles-module--cause--19vnS","cause__title":"styles-module--cause__title--cr0XW","cause__desc":"styles-module--cause__desc--1Hp5e","star":"styles-module--star--1JAdj"};